/*
  Thumbnail-first media loading (hero, Instagram gallery, image slider).

  The container shows the media's own thumbnail immediately. The overlay is
  only cross-faded away once the video has actually PAINTED its first frame —
  not merely when it reports it "can play". Fading on canplay leaves a gap
  where the <video> box is still empty, which reads as a black flash.

  If the video errors, stalls, or autoplay is blocked, the thumbnail simply
  stays: a still image is always better than an empty box.

  On very slow connections (2G / Save-Data) the video is never fetched at all,
  so the bandwidth goes to the thumbnail and slow-network visitors reliably
  get the image.
*/
(function () {
  function firstFramePainted(video, cb) {
    var done = false;
    function fire() {
      if (done) return;
      done = true;
      cb();
    }

    // Most accurate: fires when a frame has been presented for display.
    if (typeof video.requestVideoFrameCallback === 'function') {
      video.requestVideoFrameCallback(fire);
    }

    // Fallbacks for browsers without rVFC: 'playing' plus a paint tick, and a
    // timeupdate (currentTime only advances once frames are being shown).
    video.addEventListener('playing', function () {
      requestAnimationFrame(function () { requestAnimationFrame(fire); });
    }, { once: true });

    video.addEventListener('timeupdate', function onTime() {
      if (video.currentTime > 0) {
        video.removeEventListener('timeupdate', onTime);
        fire();
      }
    });

    // Video already running by the time we attached (cached/instant start)
    if (!video.paused && video.currentTime > 0 && video.readyState >= 2) {
      requestAnimationFrame(fire);
    }
  }

  function setup() {
    var conn = navigator.connection || navigator.webkitConnection;
    var slowNet = !!(conn && (conn.saveData || /(^|\b)(slow-)?2g$/.test(conn.effectiveType || '')));

    document.querySelectorAll('[data-video-blur-load]').forEach(function (overlay) {
      if (overlay.dataset.blurInit) return;
      overlay.dataset.blurInit = '1';
      var container = overlay.closest('[data-video-container]');
      if (!container) return;
      var video = container.querySelector('video');
      if (!video) return;

      if (slowNet) {
        // Keep the thumbnail, skip the video: stripping the sources stops any
        // fetch, and play() calls elsewhere reject harmlessly.
        video.removeAttribute('autoplay');
        video.preload = 'none';
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(function (s) { s.remove(); });
        try { video.load(); } catch (e) {}
        container.setAttribute('data-video-skipped', 'true');
        return;
      }

      firstFramePainted(video, function () {
        // The video is now showing real pixels — safe to cross-fade the
        // thumbnail out. The overlay stays in the DOM (opacity 0) so a later
        // repaint can never expose an empty box.
        overlay.classList.add('is-loaded');
      });

      // Deliberately no 'error' / 'stalled' handling that reveals the video:
      // on failure the thumbnail stays put.
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setup); }
  else { setup(); }
})();
